import { render, staticRenderFns } from "./ShortVideos.vue?vue&type=template&id=8e2c4544"
import script from "./ShortVideos.vue?vue&type=script&lang=js"
export * from "./ShortVideos.vue?vue&type=script&lang=js"
import style0 from "./ShortVideos.vue?vue&type=style&index=0&id=8e2c4544&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports